import { configureStore } from '@reduxjs/toolkit';
import agreementReducer from './slices/agreementSlice';
import shopifyConnectionReducer from './slices/shopifyConnection';
import createStoreReducer from "./slices/createStore"
import saveFilterReducer from './slices/dataFilter';
import dataSyncReducer from './slices/dataSync'
import getAssociationTypeReducer from './slices/getAssociationType'
import getConfigReducer from './slices/getConfig';
import getFilterDataReducer from './slices/getFilterData'
import getPImAttributesReducer from './slices/getPImAttributes'
import getSassConfigReducer from "./slices/getSaasConfig"
import linkResetReducer from "./slices/linkReset"
import loginReducer from "./slices/login"
import pimConnectionReducer from './slices/pimConnection';
import saveCredReducer from './slices/saveCredentials';
import saveProductMappingReducer from './slices/saveProductMapping';
import statusReducer from "./slices/syncStatus";
import retreiveSalesChannelReducer from "./slices/retreiveSalesChannel";
import getCategoriesReducer from "./slices/getCategories";
import storeLimitReducer from "./slices/storeLimit";
import createPreExistingProductCatlogReducer from "./slices/createPreExistingProduct";
import createPreExistingCategoriesCatlogReducer from "./slices/createPreExistingCategories";
import previewSyncDetailReducer from "./slices/previewSyncDetails";
import getShopifyAppConfigReducer from"./slices/getShopifyAppConfig";
import agreementAcceptFlagReducer from "./slices/agreementAcceptFlag";
import plansReducer from "./slices/getPlanDetails";
import registerSubscriptionReducer from "./slices/registerSubscription";
import appReducer from './slices/appSlice';
import assetFamilesReducer from './slices/assetsFamiliesSlice';
import getShopifyMarketsReducer from './slices/getShopifyMarketsSlice'

const store = configureStore({
  reducer: {
    app: appReducer,
    agreement: agreementReducer,
    data: pimConnectionReducer,
    shopifyConnection: shopifyConnectionReducer,
    saveCreds: saveCredReducer,
    dataFilters: saveFilterReducer,
    PImAttributes: getPImAttributesReducer,
    associationOptions: getAssociationTypeReducer,
    productMapping: saveProductMappingReducer,
    config: getConfigReducer,
    filtersOptions: getFilterDataReducer,
    dataSync: dataSyncReducer,
    loginData: loginReducer,
    getSaasAppConfig: getSassConfigReducer,
    createStore: createStoreReducer,
    syncStatus: statusReducer,
    linkReset: linkResetReducer,
    salesChannel: retreiveSalesChannelReducer,
    rootCategories: getCategoriesReducer,
    storeLimit: storeLimitReducer,
    preExistingProductCatalog : createPreExistingProductCatlogReducer,
    preExistingCategoriesCatlog : createPreExistingCategoriesCatlogReducer,
    previewSyncDetail : previewSyncDetailReducer,
    shopifyAppConfig : getShopifyAppConfigReducer,
    agreementAcceptFlag: agreementAcceptFlagReducer,
    plans: plansReducer,
    subscriptionDetails: registerSubscriptionReducer,
    assetFamilies: assetFamilesReducer,
    shopifyMarkets: getShopifyMarketsReducer
  },
});

export default store;
